module.exports = __webpack_public_path__ + "05491f9b6e70372c7341f67e02c59e52.pdf";